module.exports = __webpack_public_path__ + "static/media/md-exit.b2136cd6.svg";